
import $ from 'jquery';
import mixitup from 'mixitup';

import 'intersection-observer';
import 'jquery.easing';

import debounce from './util/debounce';
import globals from './global/globals';
import globalelements from './global/elements';
import logger from './logger';

export default function (options) {
    var o = $.extend({
        $e: null,
        selector: 'body',

        gridSelector: '#filtergrid',
        filterSelector: '[data-is-filter]',
        blockSelector: '.filtergrid__block',
        paginateSelector: '.filtergrid__paginate',

        paginateSeekAheadDist: '200%',

        // move items to make sure grid is always
        // filled without gaps
        fill: {
            enabled: true,

            // the number of columns in a row
            colsInRow: 12,

            // these sizes (in columns) must match what's
            // set in filtergrid.scss
            sizes: {
                small: 4,
                half: 6,
                medium: 8,
                mediumRowLeft: 12,
                mediumRowRight: 12,
                large: 12
            },

            // if no items on the page can be found to fill a row
            // force resize whatever the next item is to fill row.
            // forceFit also assumes that small + medium = full row
            // and that half + half = full row.
            // IF ALLOWING the "half" SIZE, THIS MUST BE ENABLED
            forceFit: true,

            // if forceFit is enabled, set block selectors that
            // should never be resized, such as pagination dividers
            forceFitIgnore: '[data-size=divider], [data-size=mediumRowLeft], [data-size=mediumRowRight], [data-size=large]',

            // turns on a debug overlay on top of blocks
            debug: false
        },

        // while ajax fetch is happening, show busy cursor?
        loadingCursor: true,

        // matches value in css, but doesnt have to
        transitionSpeed: globals.anim.transitionSpeed,

        devMode: true
    }, options);


    var ele = $.extend({
        grid: $(o.gridSelector), // container of all grid elements
        filters: $(o.filterSelector), // things you click to filter
        blocks: $(o.blockSelector),
        paginate: $(o.paginateSelector),
        showLoadingCursorOn: $('header, main')
    }, globalelements);


    var intrn = {
        name: 'Grid',
        $e: o.$e || $(o.selector),

        winWidth: ele.win.width(),

        itemObserver: null,
        paginateObserver: null,

        grid: null,
        isArranging: false,

        pageinateURL: null,

        historyIndex: 0,
        history: [],
        pageinateURLHistory: []
    };


    var fn = {
        init: function () {
            if (!ele.grid.length > 0) return;

            // initial data, pushstate & history save
            var path = window.location.pathname;

            ele.blocks.each(function (i) {
                var block = $(this);
                block.attr('data-index-' + intrn.historyIndex, i);
                block.attr('data-size-' + intrn.historyIndex, block.data('size'));
            });

            intrn.history[intrn.historyIndex] = ele.blocks;

            window.history.pushState({
                index: intrn.historyIndex,
                href: path
            }, '', path);

            fn.setActiveFilters(path);

            // set item order to fill gaps, setup mixitup
            // then tell mixitup to sort w/o animation
            fn.fillGridGaps(ele.blocks);
            fn.setupGrid();
            intrn.grid.sort('index-' + intrn.historyIndex, false);

            // setup intersection observer to do the in-view animations
            intrn.itemObserver = new window.IntersectionObserver(handlers.itemObserver);
            ele.blocks.addClass(globals.classes.state.hidden);
            fn.observeBlocks(ele.blocks);

            // setup pagination if present
            fn.setupPagination((ele.paginate.length > 0 ? ele.paginate.attr('href') : null));

            // event handlers
            ele.filters.on('click', handlers.filterClick);
            ele.win.on('resize', debounce(handlers.resize, 100));

            window.onpopstate = handlers.popstate;
        },

        setupGrid: function () {
            intrn.grid = mixitup(o.gridSelector, {
                selectors: {
                    target: o.blockSelector
                },
                animation: {
                    duration: o.transitionSpeed,
                    reverseOut: true,
                    easing: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
                    effects: 'fade translateY(-400px) stagger(50ms)',
                    animateResizeContainer: false
                },
                behavior: {
                    liveSort: true
                },
                debug: {
                    showWarnings: false
                },
                callbacks: {
                    onMixEnd: handlers.onMixEnd
                }
            });

            fn.console('grid set up');
        },

        setupPagination: function (paginateURL) {
            // save current pagination URL, regardless
            // of whether pagination is setup or not
            intrn.pageinateURLHistory[intrn.historyIndex] = paginateURL;

            // setup the pagination observer
            if (paginateURL) {
                fn.addPagination(paginateURL);
            } else {
                fn.removePagination();
            }
        },
        addPagination: function (paginateURL) {
            intrn.pageinateURL = paginateURL;

            if (!intrn.paginateObserver) {
                intrn.paginateObserver = new window.IntersectionObserver(handlers.paginateObserver, {
                    root: null,
                    rootMargin: o.paginateSeekAheadDist,
                    threshold: 0
                });
            }

            intrn.paginateObserver.observe(ele.paginate[0]);
        },
        removePagination: function () {
            intrn.pageinateURL = null;

            if (intrn.paginateObserver) {
                intrn.paginateObserver.unobserve(ele.paginate[0]);
            }
        },

        changeGrid: function (newBlocks, isNavigatingHistory, isPaginating) {
            var index = intrn.historyIndex;

            // start off with all current blocks as blocks
            // that are going to be removed
            if (!isPaginating) {
                var leavingBlocks = ele.blocks;
            } else {
                var startingCount = intrn.grid.getState().totalShow;
            }

            var visibleBlocks = $([]);

            // turn off live sorting while updating indicies
            intrn.grid.configure({
                behavior: {
                    liveSort: false
                }
            });

            // grey out old debug messages, and remove even older ones
            if (o.fill.enabled && o.fill.debug) {
                ele.blocks.find('.filtergrid__block__debugmsg')
                    .css('opacity', '0.3')
                    .filter('[data-index=' + index + ']')
                    .css('opacity', '');
            }

            // for each incoming block, see if it's one of the blocks
            // currently on the page, and if it is, remove it from
            // the array of objects that will be removed
            // also, update the sort index of all blocks
            newBlocks.each(function (i) {
                var newBlock, id, oldSameBlock, oldSameBlockExists, order;

                newBlock = $(this);
                id = newBlock.data('id');
                oldSameBlock = ele.blocks.filter('[data-id=' + id + ']');
                oldSameBlockExists = (oldSameBlock.length > 0);

                // the way the blocks are ordered depends if we're
                // loading new content in, or navigating the
                // history using popstate
                if (isNavigatingHistory) {
                    // a matching old block will stay hidden this way
                    // because the index will remain as "false"
                    order = newBlock.attr('data-index-' + index);
                } else if (isPaginating) {
                    order = startingCount + i + 1;
                } else {
                    // otherwise, just order em the way they came in
                    order = i;
                }

                if (oldSameBlockExists) {
                    oldSameBlock.attr('data-index-' + index, order);
                    newBlocks = newBlocks.not(newBlock);
                    visibleBlocks = visibleBlocks.add(oldSameBlock);

                    // if it was a forceFit block, and we're going
                    // thru history, set size for this history state
                    // note that only blocks with data-original-size
                    // will have been forceFit
                    if (o.fill.enabled && isNavigatingHistory && oldSameBlock.is('[data-original-size]')) {
                        oldSameBlock.attr('data-size', oldSameBlock.attr('data-size-' + index));
                    }

                    if (!isPaginating) {
                        leavingBlocks = leavingBlocks.not(oldSameBlock);
                    }
                } else {
                    newBlock.addClass(globals.classes.state.hidden);
                    newBlock.attr('data-index-' + index, order);
                    visibleBlocks = visibleBlocks.add(newBlock);
                    ele.blocks = ele.blocks.add(newBlock);

                    // add new filters that might be inside block
                    var newFilters = newBlock.find(o.filterSelector);
                    newFilters.on('click', handlers.filterClick);
                    ele.filters = ele.filters.add(newFilters);
                }
            });

            // all other non-matching blocks get set to hidden
            if (!isPaginating) {
                leavingBlocks.attr('data-index-' + index, false);
            }

            // fill gaps if enabled and not navigating history
            if (o.fill.enabled && !isNavigatingHistory) {
                fn.fillGridGaps(visibleBlocks);
            }

            // turn back on live sorting, and
            // turn off animations if paginating
            intrn.grid.configure({
                animation: {
                    enable: !isPaginating
                },
                behavior: {
                    liveSort: true
                }
            });

            // add new incoming items; and sort + filter
            // all blocks by the data-index for the history index
            fn.setArrangingState();
            intrn.grid.multimix({
                insert: {
                    collection: newBlocks,
                    index: intrn.grid.getState().totalShow
                },
                filter: ':not([data-index-' + index + '=false])',
                sort: 'index-' + index
            }).catch(console.error.bind(console));

            // save the current list of all blocks (both visible
            // and hidden), into the history
            intrn.history[index] = ele.blocks;

            // add the new blocks to the intersection observer, and
            // tell the lazyloader to look at all the new blocks
            fn.observeBlocks(newBlocks);
            ele.doc.trigger('lazyloaderNewElementsAdded', {
                elements: newBlocks
            });
        },

        fillGridGaps: function (blocks) {
            // move items to fill and gaps in the grid!
            if (!o.fill.enabled) return;

            var remainingBlocks, rowFill, thisRow, previousRow, index;

            // first make sure elements are sorted in proper order
            blocks.sort(function (a, b) {
                a = parseInt($(a).attr('data-index-' + intrn.historyIndex), 10);
                b = parseInt($(b).attr('data-index-' + intrn.historyIndex), 10);
                return ((a < b) ? -1 : ((a > b) ? 1 : 0));
            });

            remainingBlocks = blocks;
            rowFill = 0;
            thisRow = [];
            previousRow = [];

            // start the indexing at whatever the earliest block is
            // (don't want to start at 0 if a paginated page)
            index = parseInt(blocks.first().attr('data-index-' + intrn.historyIndex), 10);

            // gets the width of a block in columns based on
            // the data-size attribute it's been given
            function getBlockCols (block) {
                return o.fill.sizes[block.attr('data-size')] || o.fill.colsInRow;
            }

            // if block has previously been resized with forceFit,
            // set it back to its original size
            function resetForceFit (block) {
                var origSize = block.attr('data-original-size');
                if (origSize && origSize !== '') {
                    block.attr('data-size', origSize);
                }
            }

            function setBlockSizeHistory (block, size) {
                size = size || block.attr('data-size');
                block.attr('data-size-' + intrn.historyIndex, size);
            }

            // if there are two rows that are the same order of
            // medium + small blocks in a row, reverse the second
            function reverseRowIfRepeat (firstBlock, secondBlock) {
                // console.log(previousRow, thisRow);
                if (thisRow[0] === previousRow[0] && 
                    thisRow[1] === previousRow[1] && (
                    (thisRow[0] === 'medium' && thisRow[1] === 'small') || 
                    (thisRow[0] === 'small' && thisRow[1] === 'medium'))) {
                    var firstBlockIndex = firstBlock.attr('data-index-' + intrn.historyIndex);
                    var secondBlockIndex = secondBlock.attr('data-index-' + intrn.historyIndex);

                    firstBlock.attr('data-index-' + intrn.historyIndex, secondBlockIndex);
                    secondBlock.attr('data-index-' + intrn.historyIndex, firstBlockIndex);

                    debugOverlay(firstBlock, 'reversed', 'background: #fff; color: #000');
                    debugOverlay(secondBlock, 'reversed', 'background: #fff; color: #000');

                    thisRow = [thisRow[1], thisRow[0]];
                }
            }

            // debug overlay
            function debugOverlay (block, msg, css) {
                if (!block.data('debugOverlay')) {
                    block.data('debugOverlay', $('<div style="position: absolute; top: 0; right: 0; font-size: 1rem; line-height: 0.9; text-align: right; text-transform: uppercase; font-family: \'Pilat Compressed Web\', sans-serif; font-weight: bold;"></div>'));
                    block.find('.media').append(block.data('debugOverlay'));
                }
                if (o.fill.debug) {
                    var markup = '<div class="filtergrid__block__debugmsg" data-index="' + intrn.historyIndex + '" style="display: flex; justify-content: flex-end;"><div style="padding: 0 0.2em 0.1em 0.2em; background: black; color: white; ' + (!css ? '' : css) + '">' + msg + '</div></div>';
                    block.data('debugOverlay').append(markup);
                }
            };

            // this starts by looking at a block, then looking at
            // all subsequent blocks after that one to cleanly
            // fill a whole row with no gaps. after a row is complete
            // it looks at the next block that has not yet been ordered
            // and repeats the process until no blocks are left unassigned.
            // if it can't fill a row completely
            // completely
            function processBlock (block) {
                resetForceFit(block);
                setBlockSizeHistory(block);

                var blockCols = getBlockCols(block);

                block.attr('data-index-' + intrn.historyIndex, index);
                index++;

                rowFill = rowFill + blockCols;

                remainingBlocks = remainingBlocks.not(block);

                if (rowFill <= o.fill.colsInRow - o.fill.sizes.small) {
                    debugOverlay(block, 'ends at column ' + rowFill);

                    thisRow.push(block.attr('data-size'));

                    var numFutureBlocks = remainingBlocks.length;

                    remainingBlocks.each(function (i) {
                        var futureBlock, futureBlockCols, newRowFill;

                        futureBlock = $(this);

                        resetForceFit(futureBlock);
                        setBlockSizeHistory(block);

                        futureBlockCols = getBlockCols(futureBlock);
                        newRowFill = rowFill + futureBlockCols;

                        // if we're allowing 6-column blocks,
                        // we must have forceFit enabled.
                        // if not, use this for the if statement below:
                        // if (newRowFill <= o.fill.colsInRow)
                        // ^ (IL 1/10/19: actually might be able to leave as is)
                        // the if statment below here is for when 6-column
                        // blocks are possible which makes sure that if
                        // we're leaving extra room in the row, at least a
                        // "small" block would be able to fit there
                        if (newRowFill === o.fill.colsInRow ||
                            newRowFill <= o.fill.colsInRow - o.fill.sizes.small) {
                            futureBlock.attr('data-index-' + intrn.historyIndex, index);
                            index++;

                            rowFill = rowFill + futureBlockCols;

                            debugOverlay(futureBlock, 'ends at column ' + rowFill);
                            debugOverlay(futureBlock, 'moved');

                            remainingBlocks = remainingBlocks.not(futureBlock);

                            thisRow.push(futureBlock.attr('data-size'));

                            // if we've perfectly completed the row,
                            // reset rowfill and exit loop
                            if (newRowFill === o.fill.colsInRow) {
                                debugOverlay(futureBlock, 'end of line', 'background: #0068e9');
                                rowFill = 0;

                                reverseRowIfRepeat(block, futureBlock);
                                previousRow = thisRow;
                                thisRow = [];

                                return false;
                            }
                        }

                        // if we've just checked the last remaining block for
                        // a fit and there's no fit, optionally force whatever
                        // the next block is to fill row (i.e., resize it),
                        // and reset rowFill counter to 0
                        if (i === numFutureBlocks - 1 && rowFill < o.fill.colsInRow) {
                            if (o.fill.forceFit) {
                                var nextBlock, forcedNewSize;

                                nextBlock = remainingBlocks.not(o.fill.forceFitIgnore).first();

                                if (nextBlock.length > 0) {
                                    if (rowFill === o.fill.sizes.medium) {
                                        forcedNewSize = 'small';
                                    } else if (rowFill === o.fill.sizes.half) {
                                        forcedNewSize = 'half';
                                    } else if (rowFill === o.fill.sizes.small) {
                                        forcedNewSize = 'medium';
                                    }
                                }

                                if (forcedNewSize) {
                                    // save original size if not already set
                                    if (!nextBlock.attr('data-original-size')) {
                                        nextBlock.attr('data-original-size', nextBlock.attr('data-size'));
                                    }

                                    nextBlock.attr('data-size', forcedNewSize);
                                    nextBlock.attr('data-index-' + intrn.historyIndex, index);

                                    setBlockSizeHistory(nextBlock, forcedNewSize);

                                    thisRow.push(forcedNewSize);

                                    index++;

                                    remainingBlocks = remainingBlocks.not(nextBlock);

                                    debugOverlay(nextBlock, 'force resized', 'background: #fe5000;');
                                    debugOverlay(nextBlock, 'ends at column' + o.fill.colsInRow);
                                    debugOverlay(nextBlock, 'end of line', 'background: #0068e9');
                                }
                            }

                            // either way, if forcefit finds something
                            // or doesn't (or isn't enabled) reset the row
                            rowFill = 0;

                            reverseRowIfRepeat(block, nextBlock);
                            previousRow = thisRow;
                            thisRow = [];
                        }
                    });
                } else {
                    debugOverlay(block, 'ends at column ' + rowFill);
                    debugOverlay(block, 'end of line', 'background: #0068e9');

                    rowFill = 0;

                    thisRow.push(block.attr('data-size'));
                    previousRow = thisRow;
                    thisRow = [];
                }

                if (remainingBlocks.length > 0) {
                    processBlock(remainingBlocks.first());
                }
            }

            if (remainingBlocks.length > 0) {
                processBlock(remainingBlocks.first());
            }
        },

        observeBlocks: function (blocks) {
            blocks.each(function () {
                intrn.itemObserver.observe($(this)[0]);
            });
        },

        setArrangingState: function () {
            intrn.isArranging = true;
            ele.body.addClass(globals.classes.state.arranging);
        },
        unsetArrangingState: function () {
            intrn.isArranging = false;
            ele.body.removeClass(globals.classes.state.arranging);
        },

        setActiveFilters: function (href) {
            ele.filters
                .removeClass(globals.classes.state.active)
                .filter('[href="' + href + '"], [data-href="' + href + '"]')
                .addClass(globals.classes.state.active);

            ele.body.attr('data-subnav-open', 'false');
        },

        fetchPage: function (href, addToHistory, isPaginating) {
            if (!href) return;

            if (o.loadingCursor) ele.body.addClass(globals.classes.state.loading);

            $.ajax({
                url: href
            }).done(function (data) {
                var newPage, newBlocks, newPagination;

                newPage = $(data);
                newBlocks = newPage.find(o.gridSelector + ' ' + o.blockSelector);
                newPagination = newPage.find(o.paginateSelector);

                // for paginating on filter pages, skip over
                // repeats of the filter header
                if (isPaginating) {
                    newBlocks = newBlocks.not('[data-ignore-on-pagination]');
                }

                if (addToHistory) {
                    intrn.historyIndex++;

                    window.history.pushState({
                        index: intrn.historyIndex,
                        href: href
                    }, '', href);
                }

                if (o.loadingCursor) ele.body.removeClass(globals.classes.state.loading);

                fn.changeGrid(newBlocks, false, isPaginating);

                // if we're paginating, set the active filters to the
                // parent page's uri (e.g. the /new page without the page
                // number query)
                fn.setActiveFilters((isPaginating ? newPagination.data('page-uri') : href));

                // if new page has pagination, set pagination URL
                // to the new URL; if there isn't already a pa
                if (newPagination.length > 0) {
                    if (!ele.paginate || ele.paginate.length < 1) {
                        ele.paginate = newPagination;
                        ele.paginate.insertAfter(ele.grid);
                    }

                    fn.setupPagination(newPagination.attr('href'));
                } else {
                    fn.setupPagination(null);
                }
            });
        },

        scrollToTop: function () {
            ele.scrollbody.animate({
                scrollTop: 0
            }, {
                duration: o.transitionSpeed,
                easing: globals.anim.easing
            });
        },

        console: function (msgs) {
            if (o.devMode) {
                logger(msgs, {
                    prefix: intrn.name + '.js',
                    prefixColor: 'magenta'
                });
            }
        }
    };


    var handlers = {
        onMixEnd: function (e) {
            fn.console('mix complete');

            // wait for repaint before reapplying the in-view animations
            setTimeout(function () {
                fn.unsetArrangingState();
            }, 5);
        },
        filterClick: function (e) {
            e.preventDefault();

            var filter = $(this);
            var href = filter.attr('href') || filter.data('href');

            // don't do anything if trying to navigate to the
            // current page, or if grid is mid-arranging
            if (href === window.location.pathname || intrn.isArranging) {
                return;
            }

            fn.setArrangingState();
            fn.scrollToTop();
            fn.fetchPage(href, true);
        },
        popstate: function (e) {
            if (e.state && e.state.index >= 0) {
                intrn.historyIndex = e.state.index;
                fn.setActiveFilters(e.state.href);
                fn.changeGrid(intrn.history[intrn.historyIndex], true);
                fn.setupPagination(intrn.pageinateURLHistory[intrn.historyIndex]);
            } else {
                window.history.back();
            }
        },
        itemObserver: function (entries) {
            $.each(entries, function (i, entry) {
                if (entry.isIntersecting) {
                    var blockCenter, viewOffsetFromMid, centerMargin;

                    blockCenter = entry.boundingClientRect.left + (entry.boundingClientRect.width / 2);

                    viewOffsetFromMid = intrn.winWidth / 2 - blockCenter;

                    centerMargin = intrn.winWidth * 0.15;

                    entry.target.classList.add(globals.classes.state.noanimate);

                    if (viewOffsetFromMid < -1 * centerMargin) {
                        entry.target.setAttribute('offset', 'right');
                    } else if (viewOffsetFromMid >= -1 * centerMargin && viewOffsetFromMid <= centerMargin) {
                        entry.target.setAttribute('offset', 'center');
                    } else {
                        entry.target.setAttribute('offset', 'left');
                    }

                    // entry.target.setAttribute('offsetval', viewOffsetFromMid);

                    setTimeout(function () {
                        entry.target.classList.remove(globals.classes.state.noanimate);
                        entry.target.classList.remove(globals.classes.state.hidden);
                    }, 25);

                    intrn.itemObserver.unobserve(entry.target);
                }
            });
        },
        paginateObserver: function (entries) {
            $.each(entries, function (i, entry) {
                if (entry.isIntersecting) {
                    fn.fetchPage(intrn.pageinateURL, false, true);
                }
            });
        },
        resize: function (e) {
            intrn.winWidth = ele.win.width();
        }
    };


    fn.init();
}
